export const customerFullname = (customer: Customer | User) =>
	`${customer.firstname} ${customer.lastname}`;
